import React from 'react'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Navbar from '../components/Navbar'
import Banner from '../components/Banner'
import TrainingSection from '../components/Training'
import Features from '../components/features/Features'
import MultiItemCarousel from '../components/partners/MultiItemCarousel'

const Training = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='About Us' text=' More about Africa Mining Summit Investment 2024' />
            <TrainingSection />
            <Banner />
            <Features/>
            <MultiItemCarousel />
            <Footer />
        </div>
    )
}

export default Training
